import { NavLink, useLocation } from "react-router-dom";
import FolderOpen from "@material-ui/icons/FolderOpen";
import SortOutlinedIcon from "@material-ui/icons/SortOutlined";
import AccessTime from "@material-ui/icons/AccessTime";
import ContactSupportIcon from "@material-ui/icons/ContactSupport";
import FingerprintOutlined from "@material-ui/icons/FingerprintOutlined";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";
import OTISLogo from "../../assets/MKTGFLO-Logo-RGB-Positive.png";
import DCMLogo from "../../assets/DCM-Logo-EN-RGB-01.png";

import {
  BottomNav,
  CopyrightWrapper,
  DCMLogoImgWrapper,
  FooterNav,
  LogoImgWrapper,
  LogoWrapper,
  TopNav,
  Wrapper,
} from "./index.styles";
import { BRANDING, PAGES } from "../../features/navigation/types/pages.constant";
import { NavButton } from "../form-controls/button/nav-button/nav-button.component";
import { notFlag } from "../filters/forms/filters.constants";

const AppNavBar = () => {
  const topNavs = [
    {
      page: PAGES.CAMPAIGN_BRIEFS,
      icon: <FolderOpen />,
      focusUrls: [PAGES.CAMPAIGN_BRIEFS.URL, PAGES.CAMPAIGN_BRIEF.URL],
    },
    {
      page: PAGES.EXECUTION_BRIEFS_LIST,
      icon: <SortOutlinedIcon />,
      focusUrls: [PAGES.EXECUTION_BRIEFS_LIST.URL, PAGES.EXECUTION_BRIEF.URL],
    },
    {
      page: PAGES.WORK_ORDERS_LIST,
      icon: <AccessTime />,
      focusUrls: [PAGES.WORK_ORDERS_LIST.URL, PAGES.WORK_ORDER.URL],
      search: `?status=${notFlag}approved`,
    },
    {
      page: PAGES.FLYERS,
      icon: <DescriptionOutlinedIcon />,
      focusUrls: [PAGES.FLYERS.URL],
    },
    {
      page: PAGES.DAM,
      icon: <FingerprintOutlined />,
      focusUrls: [PAGES.DAM.URL],
    },
  ];

  const bottomNavs = [
    { page: PAGES.SUPPORT, icon: <ContactSupportIcon />, focusUrls: [PAGES.SUPPORT.URL] },
  ];

  const getBaseUrl = (pathnameString: string): string => "/" + pathnameString.split("/")[1];

  const { pathname } = useLocation();
  const currentBaseUrl = getBaseUrl(pathname);

  const isCurrentTitle = (focusNames: string[]): boolean => focusNames.includes(currentBaseUrl);

  return (
    <Wrapper role="region" aria-label="Main Navigation">
      <TopNav>
        <LogoWrapper>
          <LogoImgWrapper src={OTISLogo} alt={BRANDING.APPLICATION.TITLE} />
        </LogoWrapper>

        <nav id="nav">
          {topNavs.map((nav) => (
            <NavButton
              key={nav.page.URL}
              // @ts-expect-error
              component={NavLink}
              to={{ pathname: nav.page.URL, search: nav.search }}
              startIcon={nav.icon}
              fullWidth={isCurrentTitle(nav.focusUrls)}
            >
              {nav.page.TITLE}
            </NavButton>
          ))}
        </nav>
      </TopNav>

      <BottomNav>
        {bottomNavs.map((nav) => (
          <NavButton
            key={nav.page.URL}
            // @ts-expect-error
            component={NavLink}
            to={nav.page.URL}
            startIcon={nav.icon}
            fullWidth={isCurrentTitle(nav.focusUrls)}
          >
            {nav.page.TITLE}
          </NavButton>
        ))}

        <FooterNav>
          <div>
            <DCMLogoImgWrapper src={DCMLogo} alt={BRANDING.PARTNER.TITLE} />
          </div>
          &nbsp;
          <CopyrightWrapper>&#169;&nbsp;2023</CopyrightWrapper>
        </FooterNav>
      </BottomNav>
    </Wrapper>
  );
};

export default AppNavBar;
